
export interface Alert {
  message: string;
  type: AlertType;
  fadeOut: boolean;
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}
